import React from 'react';
import { Column, Row, Button, cls } from '../../packages/components';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Assets from '../../requests/apa/Asset';
import PropTypes from 'prop-types';
import Device from '../../devices/device';
import { alertHideTime } from '../../payments/utils/Utils';
import './styles/AAFModalChangePaymentMethod.scss';

const BodyContent = ({ props }) => {
    return (
        <Row className="aaf-modal-change-payment-method">
            <Row className="aaf-modal-change-payment">
                <Column lg={12}>
                    <img
                        src={Assets.get(`defaultPaymentMethod_update_icon_confirm`)}
                        alt="Check_logo"
                    />
                </Column>
                <Column lg={12}>
                    <p>
                        {Translator.get(
                            'defaultPaymentMethod_update_description_label',
                            'Medio de pago actualizado'
                        )}
                    </p>
                </Column>
                <Column lg={12} className="aaf-modal-button-change-space">
                    <Button
                        activate
                        type="button"
                        variant="primary"
                        className={cls('focusable', 'aaf-modal-button-change-payment')}
                        onClick={(e) => {
                            props.handleClose(e, props.callback);
                        }}
                    >
                        {Translator.get(
                            'defaultPaymentMethod_update_option_button_close',
                            'Aceptar'
                        )}
                    </Button>
                </Column>
            </Row>
        </Row>
    );
};

const AAFModalChangePaymentMethod = (props = {}) => {
    const device = Device.getDevice().getPlatform();
    const customizedClassName = `modal-button-return`;
    const p = {
        alwaysEnabled: true,
        buttonsAlign: 'vertical',
        aafNewStyle: true,
        className: 'aaf-modal',
        showLogo: true,
        yellowAction: (e) => props.handleClose(e),
        colorButtons: props.data
            ? [
                  {
                      content: Translator.get('top_head_option_button_back', 'REGRESAR'),
                      props: {
                          color: 'yellow',
                          className: customizedClassName,
                          imgSrc: Assets.get('top_head_option_back', ''),
                          onClick: (e) => props.handleClose(e, props.callback),
                      },
                  },
              ]
            : null,
    };
    setTimeout((e) => {
        props.handleClose(e, props.callback);
    }, alertHideTime()*1000);
    return (
        <ModalWrapper {...p}>
            <BodyContent props={props} />
        </ModalWrapper>
    );
};

AAFModalChangePaymentMethod.propTypes = {
    content: PropTypes.string,
    className: PropTypes.string,
};

export default withOnClose(AAFModalChangePaymentMethod);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalChangePaymentMethod.jsx